import { useLanguage } from "@/i18n/LanguageContext";

export default function HeroSection() {
  const { t } = useLanguage();

  return (
    <section className="w-full bg-[#fefce8] py-10 md:py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div className="max-w-xl">
          <h1 className="font-roboto font-bold text-3xl md:text-[42px] text-[#064e3b] leading-tight mb-4">
            {t("glass.h1")}
          </h1>
          <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-6">
            {t("glass.subhead")}
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="tel:+17863774452"
              className="inline-flex items-center justify-center gap-2 bg-[#ea580c] text-white px-6 py-3.5 text-sm font-bold rounded-lg hover:bg-[#c2410c] transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line" />
              Call (786) 377-4452
            </a>
            <a
              href="/contact/"
              className="inline-flex items-center justify-center gap-2 bg-white border-2 border-[#064e3b] text-[#064e3b] px-6 py-3.5 text-sm font-bold rounded-lg hover:bg-[#064e3b] hover:text-white transition-colors whitespace-nowrap"
            >
              Get Phone Quote
            </a>
          </div>
        </div>
        <div className="flex justify-center lg:justify-end">
          <img
            src="https://storage.readdy-site.link/project_files/76915537-ee3f-4564-9a23-41bd98b5df27/ba85f0f3-03f0-416a-afa2-7da43eabbb9d_glass-replacement-.jpg?v=36ecc67ba486e26081168998b034e11d"
            alt="Non-impact window glass replacement Miami-Dade homes"
            className="rounded-xl w-full max-w-[520px] object-cover"
          />
        </div>
      </div>
    </section>
  );
}